import useRequest from 'src/Composables/useRequest';

export const createErrorsModule = (endpoint) => ({
        namespaced: true,
        state: {
                errors: [],
                loading: false,
        },
        mutations: {
                SET_ERRORS(state, errors) {
                        state.errors = errors;
                },
                REMOVE_ERROR(state, errorId) {
                        state.errors = state.errors.filter(error => error.id !== errorId);
                },
                CLEAR_ERRORS(state) {
                        state.errors = [];
                },
                SET_LOADING(state, value) {
                        state.loading = value;
                },
        },
        actions: {
                async refresh({ commit }, pharmacyId) {
                        //@todo dev return for wla
                        return;
                        const readErrorsRequest = useRequest({ pharmacy_id: pharmacyId });

                        commit('SET_LOADING', true);

                        try {
                                const response = await readErrorsRequest.execute('get', endpoint);
                                commit('SET_ERRORS', response.data);
                        } catch (error) {
                                console.error('Error while fetching errors:', error);
                                // Optionally handle error state or notify user
                        } finally {
                                commit('SET_LOADING', false);
                        }
                },
                async destroy({ commit }, errorId) {
                        const destroyRequest = useRequest({});

                        try {
                                await destroyRequest.execute('delete', `${endpoint}/${errorId}`);
                                commit('REMOVE_ERROR', errorId);
                        } catch (error) {
                                console.error(`Error while deleting error ${errorId}:`, error);
                                // Optionally handle error state or notify user
                        }
                },
                async destroyAll({ commit }) {
                        const destroyAllErrorsRequest = useRequest({});

                        try {
                                await destroyAllErrorsRequest.execute('delete', endpoint);
                                commit('CLEAR_ERRORS');
                        } catch (error) {
                                console.error('Error while deleting all errors:', error);
                                // Optionally handle error state or notify user
                        }
                },
        },
        getters: {
                count: state => state.errors.length,
                errorById: state => errorId => state.errors.find(error => error.id === errorId),
                // Optionally add more getters as needed
                isLoading: state => state.loading,
        },
});
